import React, { Component } from 'react';
import { getInstagramPhoto } from '../../utils/api/services/image';

export default class SocialBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      instagramImages: []
    };
  }

  componentWillMount = () => {
    this.fetchData();
  };

  fetchData = () => {
    getInstagramPhoto()
      .then((result) => {
        this.setState({
          instagramImages: result
        });
      })
      .catch((e) => {
        console.log('не удалось получить информацию c api instagram', e);
      });
  };

  render() {
    const { instagramImages } = this.state;
    return (
      <React.Fragment>
        <div className="section social-section">
          <a
            target="_blank"
            href="https://www.instagram.com/coopervision_ru/"
            className="social-section-cell -instagram"
          >
            {' CooperVision_ru'}
          </a>
          <a
            target="_blank"
            href="https://www.facebook.com/CooperVisionRussia/"
            className="social-section-cell -facebook"
          >
            {'CooperVision Russia'}
          </a>
        </div>

        <div className="section -mobile-offset">
          <div className="gallery-row">
            {instagramImages
              && instagramImages.map((image, i) => (
                <a target="_blank" href={image.link} className="gallery-row-cell" key={i}>
                  <img src={image.url} alt="" />
                </a>
              ))}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
